import Button from "@intility/bifrost-react/Button";
import { useState } from "react";
import type { UserSyncRequest } from "~/api/types";
import {
  isFinished,
  useRequestUserSync,
  useUserSyncRequest,
} from "~/api/userSync";

function describe(request: UserSyncRequest): string {
  switch (request.status) {
    case "pending":
      return "Waiting for the sync worker…";
    case "running":
      return "Syncing…";
    case "succeeded":
      return `Done: ${request.created} created, ${request.updated} updated, ${request.disabled} disabled, ${request.conflicts} conflicts, ${request.failed} failed.`;
    case "failed":
      return `Failed: ${request.error ?? "unknown error"}`;
  }
}

// Pulls the company's users from Entra now, instead of at the next scheduled pass.
export function SyncNowCell({ companyId }: { companyId: string }) {
  const [requestId, setRequestId] = useState<string | null>(null);
  const requestSync = useRequestUserSync();
  const { data: request, error: pollError } = useUserSyncRequest(requestId);

  const busy =
    requestSync.isPending ||
    (requestId !== null && !pollError && !isFinished(request));
  const error = requestSync.error ?? pollError;

  const handleClick = () => {
    if (busy) return;
    requestSync.mutate(companyId, {
      onSuccess: (created) => setRequestId(created.id),
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Button
        small
        variant="filled"
        onClick={handleClick}
        state={busy ? "inactive" : undefined}
      >
        Sync now
      </Button>
      {error ? (
        <span className="bf-small" style={{ color: "var(--bfc-alert)" }}>
          {error instanceof Error ? error.message : String(error)}
        </span>
      ) : (
        request && (
          <span
            className="bf-small"
            style={{
              color:
                request.status === "failed"
                  ? "var(--bfc-alert)"
                  : "var(--bfc-base-c-2)",
            }}
          >
            {describe(request)}
          </span>
        )
      )}
    </div>
  );
}
